import Fx from './modules/fx';

document.addEventListener('DOMContentLoaded', () => {
    Fx.init();

    console.log('\u{1F5A5} Development by Mike Medoro');
});
